import React from "react";

import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";

import FamilyTree from "../../../pages/yourAssets/FT/FamilyTree";
import AssetsLinks from "../../../components/cases/assets";

const CasesPage = () => {
  const { pathname } = useLocation();
  let lastSegment = pathname.split("/").pop();

  const renderTab = () => {
    switch (lastSegment) {
      case "family-tree":
        return <FamilyTree />;
        break;
      case "assets":
        return <AssetsLinks />;
        break;
    }
  };
  return (
    <>
      <Box>{renderTab()}</Box>
    </>
  );
};

export default CasesPage;
